import {
  US_ASSOCIATED_STATES,
  US_DOMESTIC_COUNTRIES,
  US_MILITARY_CITIES,
  US_MILITARY_REGIONS,
} from '../constants';

type Address = {
  city: string;
  regionCode: string;
  countryCode: string;
};

export function isMilitaryAddress(addresses: Address[]): boolean {
  return addresses.some(
    ({ city, regionCode }) =>
      (regionCode && US_MILITARY_REGIONS.includes(regionCode.toUpperCase())) ||
      (city && US_MILITARY_CITIES.includes(city.toUpperCase())),
  );
}

export function isInternationalOrAssociated(addresses: Address[]): boolean {
  return addresses.some(
    ({ countryCode, regionCode }) =>
      (countryCode && !US_DOMESTIC_COUNTRIES.includes(countryCode.toUpperCase())) || // also excludes if country is associated state (e.g. GU)
      (regionCode && US_ASSOCIATED_STATES.includes(regionCode.toUpperCase())),
  );
}

/**
 * defines if address is military, international (not PR, US, VI) or associated state
 */
export default function isMilitaryInternationalOrAssociated(addresses: Address[]): boolean {
  return isMilitaryAddress(addresses) || isInternationalOrAssociated(addresses);
}
